import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.importModal';

export default defineMessages({
  importKnowledgeMap: {
    id: `${scope}.importKnowledgeMap`,
    defaultMessage: 'Import knowledge map',
  },
  replaceKnowledgeMap: {
    id: `${scope}.replaceKnowledgeMap`,
    defaultMessage: 'Replace knowledge map',
  },
  knowledgeMapReplaceSuccess: {
    id: `${scope}.success`,
    defaultMessage: 'Your knowledge Map was replaced.',
  },
  knowledgeMapName: {
    id: `${scope}.knowledgeMapName`,
    defaultMessage: 'Name',
  },
  KnowledgeMapPlaceholder: {
    id: `${scope}.KnowledgeMapPlaceholder`,
    defaultMessage: 'Enter Knowledge map name',
  },
  KnowledgeMapValidationIsRequired: {
    id: `${scope}.KnowledgeMapValidationIsRequired`,
    defaultMessage: 'Please enter a course title',
  },
  KnowledgeMapLengthError: {
    id: `${scope}.KnowledgeMapLengthError`,
    defaultMessage: 'Please enter a name less than 48 characters',
  },
  cloudURL: {
    id: `${scope}.cloudURL`,
    defaultMessage: 'Link to ePub file work',
  },
  cloudURLPlaceholder: {
    id: `${scope}.cloudURLPlaceholder`,
    defaultMessage: 'Input URL',
  },
  cloudURLValidationIsRequired: {
    id: `${scope}.cloudURLValidationIsRequired`,
    defaultMessage: 'Please see provide a valid file selection',
  },
  import: {
    id: `${scope}.import`,
    defaultMessage: 'Import',
  },
  replace: {
    id: `${scope}.replace`,
    defaultMessage: 'Replace',
  },
  next: {
    id: `${scope}.next`,
    defaultMessage: 'Next',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  unexpectedError: {
    id: `${scope}.unexpected`,
    defaultMessage: 'Sorry, some unexpected error occured',
  },
  duplicateKnowledgeMapError: {
    id: `${scope}.duplicateKnowledgeMapError`,
    defaultMessage: 'This name already exists.',
  },
  noFileSelected: {
    id: `${scope}.noFileSelected`,
    defaultMessage: 'No file selected',
  },
  importFile: {
    id: `${scope}.importFile`,
    defaultMessage: 'File to import',
  },
  importFiletype: {
    id: `${scope}.importFiletype`,
    defaultMessage: 'File format accepted are .xlsx or .csv',
  },
  warning: {
    id: `${scope}.warning`,
    defaultMessage:
      'Please don’t close this window or refresh this page until the upload is finished.',
  },
  uploadFile: {
    id: `${scope}.uploadFile`,
    defaultMessage: 'Upload your file',
  },
  tryAgain: {
    id: `${scope}.tryAgain`,
    defaultMessage: 'Try again',
  },
  uploadCompleted: {
    id: `${scope}.uploadCompleted`,
    defaultMessage: 'Upload completed',
  },
  importFailed: {
    id: `${scope}.importFailed`,
    defaultMessage:
      'Upload interrupted by a network error. Check you connection or keep your computer active.',
  },
  row: {
    id: `${scope}.row`,
    defaultMessage: 'Row',
  },
  column: {
    id: `${scope}.column`,
    defaultMessage: 'Column',
  },
  knowledgeMapDuplicateTitleFields: {
    id: `${scope}.knowledgeMapDuplicateTitleFields`,
    defaultMessage: 'Duplicate LO/EO title.',
  },
  knowledgeMapMissingTitleFields: {
    id: `${scope}.knowledgeMapMissingTitleFields`,
    defaultMessage: 'LO or EO is missing.',
  },
  knowledgeMapDuplicateShortCode: {
    id: `${scope}.knowledgeMapDuplicateShortCode`,
    defaultMessage: 'Duplicate Short Codes.',
  },
  knowledgeMapInvalidParentTitle: {
    id: `${scope}.knowledgeMapInvalidParentTitle`,
    defaultMessage: 'Invalid LO title.',
  },
  knowledgeMapLongShortCode: {
    id: `${scope}.knowledgeMapLongShortCode`,
    defaultMessage: 'Short code is too long.',
  },
  knowledgeMapLongDescription: {
    id: `${scope}.knowledgeMapLongDescription`,
    defaultMessage: 'Description is too long.',
  },
  knowledgeMapLongEnablingObjectiveTitle: {
    id: `${scope}.knowledgeMapLongEnablingObjectiveTitle`,
    defaultMessage: 'EO title is too long.',
  },
  knowledgeMapLongLearningObjectiveTitle: {
    id: `${scope}.knowledgeMapLongLearningObjectiveTitle`,
    defaultMessage: 'LO title is too long.',
  },
  invalidLOEORelationPresent: {
    id: `${scope}.invalidLOEORelationPresent`,
    defaultMessage: 'LO title should not have "what is the LO for this EO".',
  },
  knowledgeMapUploadSuccess: {
    id: `${scope}.success`,
    defaultMessage: 'Your knowledge Map was uploaded.',
  },
  knowledgeMapUploadSuccessTitle: {
    id: `${scope}.success`,
    defaultMessage: 'Success',
  },
  knowledgeMapParentMissingChildTitle: {
    id: `${scope}.knowledgeMapParentMissingChildTitle`,
    defaultMessage: 'LO has no EO.',
  },
  knowledgeMapChildMissingParentTitle: {
    id: `${scope}.knowledgeMapChildMissingParentTitle`,
    defaultMessage: '"What is the LO for this EO" is missing.',
  },
  LearningObjectiveTitlePresent: {
    id: `${scope}.LearningObjectiveTitlePresent`,
    defaultMessage: 'LO and EO should not be in the same row.',
  },
  knowledgeMapEmptySpreadsheet: {
    id: `${scope}.knowledgeMapEmptySpreadsheet`,
    defaultMessage: 'Spreadsheet contains no data.',
  },
  knowledgeMapMissingDataHeader: {
    id: `${scope}.knowledgeMapMissingDataHeader`,
    defaultMessage: 'Missing data header.',
  },
});
